<template>
  <div class="brief-tipos-disenios-datos">
    <!-- <b-table
        :key="key"
        hover
        responsive="sm" 
        class="registro"
        :items="tiposDisenios" 
        :fields="fields">
      <div slot="table-busy" class="text-center">
        <b-spinner class="table-spinner" label="Spinning" />
      </div>
    </b-table> -->

    <!-- <div class="subtitulo"> -->
    <div>
      <label>Tipos de Diseño</label>
    </div>

    <b-list-group :key="key" flush>
      <b-list-group-item v-for="tipoDisenio in tiposDisenios" :key="tipoDisenio.tipoDisenio">
        <p><i :class="{ 'fa': true,
                    'fa-check-square-o': tipoDisenio.selected,
                    'fa-square-o': !tipoDisenio.selected }"/> {{ tipoDisenio.nombre }}</p>
      </b-list-group-item>
    </b-list-group> 

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefDatos/getField',
  mutationType: 'briefDatos/updateField',
});

export default {
  name: 'BriefTiposDiseniosData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      key: 0,

      // fields: [
      //   { 
      //     key: 'tipoDisenio',
      //     label: 'Tipo'
      //   },
      // ],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'tiposDisenios',
    ]),
  },  
  created() {

  },
  destroyed() {
  },
  methods: {
    refresh() {
      this.key++;
    }
  },
  watch: {
  }    
}
</script>

<style>
  .brief-tipos-disenios-datos {
    margin-bottom: 30px;
  }
  .brief-tipos-disenios-datos .list-group .list-group-item {
    padding-left: calc(16.66667% + 12px);
  }
</style>